import type { DataMartModel } from "./model/types";

/**
 * Which data mart an entity belongs to, by name.
 *
 * The entity API (`/target-entity-dm-get`) sends `data_mart_id` but no data mart name, so the
 * model holds every entity in one graph whose `data_mart` is blank (see `buildDataMartModel`).
 * That single graph is intended: the canvas shows the complete model. The data mart is a
 * property of each entity, read from its id; the name comes from the data mart list.
 */
export const entityDataMartName = (
  record: { data_mart_id?: number | null; datamart?: string | null },
  dataMartNameById: ReadonlyMap<number, string>
): string => {
  const byId =
    record.data_mart_id != null ? dataMartNameById.get(record.data_mart_id)?.trim() : "";
  return byId || record.datamart?.trim() || "";
};

/** The data marts the model's entities belong to, by name, sorted — what the filter offers. */
export const dataMartNamesInModel = (
  model: DataMartModel | null,
  dataMartNameById: ReadonlyMap<number, string>
): string[] => {
  const names = new Set<string>();
  model?.graphs.forEach((graph) => {
    [...graph.facts, ...graph.dimensions].forEach((entity) => {
      const name = entityDataMartName(entity.record, dataMartNameById);
      if (name) {
        names.add(name);
      }
    });
  });
  return Array.from(names).sort((a, b) => a.localeCompare(b));
};
